import debugLogScriptName from '@/debug-log-script-name'

$(function() {
  $('body').on('bless', function(e) {
    var $target = $(e.target)
    var $forms = $target.is('form') ? $target : $target.find('form')
    debugLogScriptName($forms, 'save-button.js') // DEBUG
    $forms.each(function() {
      var $form = $(this)

      if (!$form.hasClass('form--prevent-disabled')) {
        $form.on('submit', function(e) {
          var $submitButtons = $form.find('[type="submit"]')

          $submitButtons.each(function() {
            var $button = $(this),
              text = $button.attr('data-submit-text')

            if (text) {
              $button
                .text(text)
                .addClass('button--submitting')
                .prop('disabled', true)
            }
          })
        })
      }
    })
  })
})
